<template>
  <div style="min-width:1290px;">
    <MyBanner />
    <MyRight />
    <div>
      <div class="w70">
        <div style="padding:20px 0;">
          <el-breadcrumb :separator-icon="ArrowRight">
            <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>关于创投</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">

          <div class="W280  WhiteBg BorderEEE">
            <h2 class="LmTitle">导航菜单 <span style="font-size:16px">Navigation</span></h2>
            <div class="list">
              <ul>
                <li @click="change(1)">
                  <div class="title" href="/aboutventureCapital" title="企业简介">
                    企业简介<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width:14px;    margin-right: 20px; ">
                      <path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z">
                      </path>
                    </svg>
                  </div>
                </li>
                <li @click="change(2)">
                  <div class="title" href="/aboutventureCapital" title="联系我们">
                    联系我们<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width:14px;    margin-right: 20px; ">
                      <path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z">
                      </path>
                    </svg>
                  </div>
                </li>
                <!-- <li> <a class="title" href="http://ctcg.pxsctgs.com/lianxi.jhtml" title="联系我们">联系我们 <div>></div> </a>
                </li> -->
              </ul>
            </div>
          </div>

          <div class="capital-content-box" v-if="jianjie">
            <div class="capital-text">
              <h4 class="Title01">企业简介</h4>
              <div class="capital-text-content">
                创投集团成立于2019年7月，2023年7月纳入市管重点企业管理，注册资本10亿元，是全市第一家获得双AA+评级的企业。2023年集团及代管公司资产总额868.4亿元。集团及代管公司现有员工216人，党员74人，6个支部。内设党群工作部、综合管理部、财务中心、融资中心、战略发展部、资产管理部、工程管理部、风控合规部、纪检监察室9个部门。合署办公后一级子公司5家（代管公司2家）。汇丰投资公司：成立于2002年1月，注册资本10.4亿元，主要业务包括商业资产运营和工业资产管理等。
              </div>
              <div class="capital-text-content">
                赣湘园区公司：成立于2021年11月，注册资本2亿元，主要业务包括园区基础设施建设及产业发展配套设施与保障房的投资、开发、管理等。
              </div>
              <div class="capital-text-content">
                智慧城市公司：成立于2022年4月，注册资本10亿元，主要业务包括物业管理、智慧停车、光伏发电、城乡供水、综合供能、污水处理、垃圾分类等。
              </div>
              <div class="capital-text-content">
                创新建工公司：成立于2022年5月，注册资本5亿元，与建安公司（代管）合署办公，主要业务包括房屋建筑工程施工总承包和市政公用工程施工总承包以及电力、消防、装修等若干专业承包。
              </div>
              <div class="capital-text-content">
                产业招商集团：成立于2023年4月，与汇盛公司（代管）合署办公，注册资本0.3亿元，主要业务包括产业招商投资、金融服务、科创孵化等。
              </div>
            </div>
          </div>
          <div class="capital-content-box" v-if="lxwm">
            <div class="capital-text">
              <h4 class="Title01">联系我们</h4>
              <div class="capital-text-content capital-text-content1">
                地址： 江西省萍乡市萍乡经济技术开发区观丰路113号
              </div>
              <div class="capital-text-content capital-text-content1">
                电话： (+86)0799-6658636
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MyFooter />
  </div>
</template>
<script setup>
import { ArrowRight } from '@element-plus/icons-vue'
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import MyRight from "@/components/RightFixd.vue";
import { ref } from 'vue'
let jianjie = ref(true)
let lxwm = ref(false)

let change = (type) => {
  if (type == 1) {
    jianjie.value = true
    lxwm.value = false
  } else {
    jianjie.value = false
    lxwm.value = true
  }
}
</script>
<style scoped>
.w70 {
  width: 1300px;
  margin: 0 auto;
}
.capital-content-box {
  width: 75%;
  padding: 10px 0;
  box-sizing: border-box;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 14px 0 rgb(0 0 0 / 8%);
  display: flex;
  justify-content: space-between;
  min-height: 400px;
}
.capital-img {
  width: 32.8%;
  display: flex;
  justify-content: center;
}
/* .capital-text {
 
} */
.capital-text-title {
  font-size: 24px;
  color: rgba(0, 0, 0, 1);
  margin-bottom: 14px;
}
.capital-text-tip {
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
}
.capital-text-content {
  padding: 0 60px;
  font-size: 16px;
  margin-top: 15px;
  color: rgba(68, 68, 68, 1);
  text-align: justify;
  text-indent: 2em;
  line-height: 200% !important;
  font-size: 16px !important;
  font-family: "Microsoft Yahei Font", "微软雅黑" !important;
}
.capital-text-content1 {
  text-indent: 0;
}
.W280 {
  width: 280px;
}
.content {
  display: flex;
}
.BorderEEE {
  box-shadow: 0 0 14px 0 rgb(0 0 0 / 8%);
  background: #fff;
  border-radius: 5px;
  margin-right: 20px;
  height: fit-content;
}
.LmTitle {
  background: #0075c2;
  display: block;
  height: 46px;
  font-weight: 400;
  font-size: 20px;
  color: #fff;
  line-height: 46px;
  text-align: center;
}
.list > ul {
  padding-bottom: 20px;
}
ul,
ol,
li {
  list-style: none;
  list-style-type: none;
}
.list > ul > li div {
  width: 100%;
  text-indent: 25px;
  height: 42px;
  line-height: 42px;
  padding: 0;
  border-bottom: 1px solid #eee;
  display: block;
  font-size: 16px;
  position: relative;
  margin-top: 5px;
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list > ul > li a div {
  margin-right: 20px;
}
.list > ul > li:hover a {
  color: #0075c2;
}
.Title01 {
  position: relative;
  height: 38px;
  line-height: 34px;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #eee;
  color: #0075c2;
  padding: 0 20px;
  box-sizing: border-box;
}
h4.Title01:before {
  content: "";
  width: 3px;
  height: 18px;
  background: #0075c2;
  display: block;
  position: absolute;
  left: 10px;
  top: 8px;
}
</style>